export default "/fonts/vendor/summernote/dist/summernote.eot?7a3f9776e32014a85289ee4a0555e691";